import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { Title } from '@angular/platform-browser';
import { DeploymentsResource } from '../../core/resources/deployments.resource';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TeamsResource } from '../../core/resources/teams.resource';
import { format, formatDistanceToNow, parseISO } from 'date-fns';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule, SharedModule, NgApexchartsModule]
})
export class DashboardComponent implements OnInit {
    public deployments: any;
    public teams: any;

    public teamChartLabels: any;
    public teamChartData: number[] = [];
    public chartOptions: any;

    constructor(
        private readonly title: Title,
        private readonly deploymentsResource: DeploymentsResource,
        private readonly teamsResource: TeamsResource
    ) {
        this.chartOptions = {
            chart: {
                type: 'donut'
            },
            legend: {
                position: 'left'
            },
            responsive: [],
            dataLabels: {
                formatter: function (val: any, opts: any) {
                    const series = opts.w.config.series;
                    const seriesIndex = opts.seriesIndex;
                    const value = series[seriesIndex];
                    return value;
                }
            },
            plotOptions: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            total: {
                                showAlways: true,
                                show: true
                            }
                        }
                    }
                }
            }
        };
    }

    ngOnInit(): void {
        this.title.setTitle('Dashboard | Hive Mind');

        this.teamsResource.list().subscribe((x) => {
            this.teams = x;
            const teamChartLabels = this.teams.map((item: any) => item.name);

            this.deploymentsResource.list('Production', 50).subscribe((x) => {
                this.deployments = x.deployments;

                let tempData = new Array(teamChartLabels.length).fill(0);

                for (let deployment of x.deployments) {
                    let index = teamChartLabels.findIndex((team: any) => team === deployment.team.name);
                    if (index !== -1) {
                        tempData[index]++;
                    }
                }

                this.teamChartLabels = teamChartLabels.filter((_: any, index: number) => tempData[index] > 0);
                this.teamChartData = tempData.filter((value) => value > 0);
            });
        });
    }

    formatDate(dateString: string) {
        return format(parseISO(dateString), 'yyyy-MM-dd hh:mm');
    }

    formatDistanceToNow(dateString: string) {
        return formatDistanceToNow(new Date(dateString));
    }
}
